var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFerming(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    width: "50px",
    height: "50px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 6 4 L 6 39 L 7 39 C 16.734375 39 24.550781 42.894531 24.550781 42.894531 L 25 43.117188 L 25.449219 42.894531 C 25.449219 42.894531 33.265625 39 43 39 L 44 39 L 44 4 L 43 4 C 33.160156 4 25.640625 7.621094 25 7.9375 C 24.359375 7.621094 16.839844 4 7 4 Z M 8 6.089844 C 16.246094 6.324219 22.652344 9.046875 24 9.65625 L 24 40.503906 C 21.871094 39.585938 15.886719 37.300781 8 37.089844 Z M 42 6.089844 L 42 37.089844 C 34.113281 37.300781 28.128906 39.585938 26 40.503906 L 26 9.65625 C 27.347656 9.046875 33.753906 6.324219 42 6.089844 Z M 2 9 L 2 43 L 3 43 C 15.792969 43 24.59375 46.914063 24.59375 46.914063 L 25 47.09375 L 25.40625 46.914063 C 25.40625 46.914063 34.207031 43 47 43 L 48 43 L 48 9 L 46 9 L 46 41.070313 C 33.800781 41.277344 25.558594 44.710938 25 44.953125 C 24.441406 44.710938 16.199219 41.277344 4 41.070313 L 4 9 Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFerming);
export default __webpack_public_path__ + "static/media/ferming.5026a815.svg";
export { ForwardRef as ReactComponent };